
export default function HeroSection() {
  const scrollToForm = () => {
    const element = document.getElementById('advertiser-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[600px] flex items-center">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/50f4002bde5ecf02750e3107d0496ef3/dbc95933bc8c0d49d8d918b0741df7f0.jpeg')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Sponsor placements in Harmony Horizon
          </h1>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Reach residents and families in long-term care communities with clearly labeled sponsorships.
          </p>
          
          <div className="space-y-3 mb-10">
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-map-pin-line text-[#FF4D7D] text-lg" />
              </div>
              <span className="text-white/90">Local targeting by ZIP + radius</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-shield-check-line text-[#FF4D7D] text-lg" />
              </div>
              <span className="text-white/90">Brand-safe categories only</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-price-tag-3-line text-[#FF4D7D] text-lg" />
              </div>
              <span className="text-white/90">Clearly labeled sponsorships (no medical advice)</span>
            </div>
          </div>

          <button
            onClick={scrollToForm}
            className="bg-gradient-to-r from-[#6B4EFF] to-[#FF4D7D] text-white px-8 py-4 rounded-lg font-semibold text-lg hover:from-[#5A3EEE] hover:to-[#EE3C6C] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Request Sponsorship Info
          </button>
        </div>
      </div>
    </section>
  );
}
